import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps'

import { useFitBoundsWhenReady } from 'components/common/map/useFitBoundsWhenReady'
import { useFitBoundsLogic } from '../../hooks/useFitBoundsLogic'

const FitBounds = ({ previewStops, data, latitude, longitude, radius, isSuccess = true, mapMarkerType, onFitBounds, disableAutoFit }) => {
  const map = useMap()
  const mapsLib = useMapsLibrary('core')

  const effectiveData = data || previewStops

  const { fitBounds } = useFitBoundsLogic({
    map,
    mapsLib,
    data: effectiveData,
    latitude,
    longitude,
    radius,
  })

  useEffect(() => {
    if (onFitBounds) {
      onFitBounds(() => fitBounds)
    }
  }, [onFitBounds, fitBounds])

  // Refit whenever the logical inputs change — serialized so ref equality on the
  // array identity doesn't cause spurious refits.
  const refitKey = useMemo(
    () => `${latitude}|${longitude}|${radius}|${mapMarkerType}|${effectiveData?.length ?? 0}`,
    [latitude, longitude, radius, mapMarkerType, effectiveData]
  )

  useFitBoundsWhenReady({
    map,
    mapsLib,
    isSuccess,
    data: effectiveData,
    latitude,
    longitude,
    radius,
    refitKey,
    disabled: disableAutoFit,
  })

  return null
}

FitBounds.propTypes = {
  previewStops: PropTypes.array,
  data: PropTypes.array,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  radius: PropTypes.number,
  isSuccess: PropTypes.bool,
  mapMarkerType: PropTypes.string,
  onFitBounds: PropTypes.func,
  disableAutoFit: PropTypes.bool,
}

export default FitBounds
